import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivateFn, Router } from '@angular/router';
import { UserAccountIsDeactivatedWarningComponent } from '@components/dialogs/user-account-is-deactivated-warning/user-account-is-deactivated-warning.component';
import { Store } from '@ngrx/store';
import { PermissionsService } from '@shared/services/permissions.service';
import { authActions, authState } from '@sleipai/sleip-ngrx-store';

export const userAccountActivationStatusCheckGuard: CanActivateFn = () => {
  const router = inject(Router);
  const dialog = inject(MatDialog);
  const store = inject(Store<authState.State>);
  const permissionService = inject(PermissionsService);

  const isUserDeactivated = permissionService.isUserDeactivated();

  if (isUserDeactivated) {
    dialog.open(UserAccountIsDeactivatedWarningComponent, {
      height: '220px',
      width: '343px',
      disableClose: true,
      panelClass: 'user-account-is-deactivated-warning-modal-panel',
    });
    store.dispatch(authActions.logoutUser(false));
    router.navigate(['']);
    return false;
  } else {
    return true;
  }
};
